<template>
  <div>
    <Header/>

    <section id="main">
      <router-view></router-view>

      <section id="category-results">
        <div class="row clearfix">
          <h1>Individual Category Results</h1>
          <ul>
            <li v-for="cat in categories" :key="cat.id" :id="cat.id" :class="cat.id">
              <h3><router-link :to="{name:'Category', params:{catId: cat.id}}">{{ cat.title }}</router-link></h3>
            </li>
          </ul>
        </div>
      </section>

      <nav id="pages">
        <div class="row clearfix">
          <nav id="pages">
            <div class="row clearfix">
              <router-link :to="{name:'States'}" class="prev sixcol last">← States</router-link>
              <router-link :to="{name:'Appendix'}" class="next sixcol last">Appendix →</router-link>
            </div>
          </nav>
        </div>
      </nav>
    </section>
  </div>
</template>

<script>
/*eslint-disable */
export default {
  name: 'Categories',
  components: {
  },
  data () {
    return {
      categories: [
        {
          id: 'ballet-dance',
          title: 'Ballet and Dance',
        },
        {
          id: 'children-family',
          title: 'Children\'s/Family',
        },
        {
          id: 'circus-physical-theatre',
          title: 'Circus and Physical Theatre',
        },
        {
          id: 'classical-music',
          title: 'Classical Music',
        },
        {
          id: 'comedy',
          title: 'Comedy',
        },
        {
          id: 'contemporary-music',
          title: 'Contemporary Music',
        },
        {
          id: 'festivals-single-category',
          title: 'Festivals (Contemporary Music)',
        },
        {
          id: 'festivals-multi-category',
          title: 'Festivals (Multi-Category)',
        },
        {
          id: 'musical-theatre',
          title: 'Musical Theatre',
        },
        {
          id: 'opera',
          title: 'Opera',
        },
        {
          id: 'special-events',
          title: 'Special Events',
        },
        {
          id: 'theatre',
          title: 'Theatre',
        }
      ]
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>
<style lang="scss" scoped>
#category-results {
  .ballet-dance {
    background-image: url("~@/assets/img/2025/18-Ballet-+-Dance-Illume---Bangarra_credit_Daniel-Boud_164.jpg");
  }

  .children-family {
    background-image: url("~@/assets/img/2025/19-Childrens-Family-2025-IMAGE-Whirlwind-Immigration-Museum-Photographer-Laura-May-Grogan-HR-3400-Crop.jpg");
  }

  .circus-physical-theatre {
    background-image: url("~@/assets/img/2025/20-Circus-+-Physical-Theatre-Amazônia_Gluttony-Rymill-Park-_-Razan-Fakhouri-2025-(381).jpg");
  }

  .classical-music {
    background-image: url("~@/assets/img/2025/21 Classical Music AFCM 2025_20250801b 057 Final Sunset_photo credit Peter Hislop.jpg");
  }

  .comedy {
    background-image: url("~@/assets/img/2025/22-Comedy-Sydney-Comedy-Festival---Great-Laugh-in-The-Park---Image-by-Nick-Robertson---26_4_2025-(1).jpg");
  }

  .contemporary-music {
    background-image: url("~@/assets/img/2025/23-Contemporary-Music-AC-DC_Photo_Venues-NSW_Brett-Costello_20251121_891.jpg");
  }

  .festivals-single-category {
    background-image: url("~@/assets/img/2025/24-Festivals-(Contemp-Music)-Fuzzy_FieldDay_2025_CreditJordanMunns_2.jpg");
  }

  .festivals-multi-category {
    background-image: url("~@/assets/img/2025/25-Festivals-(Multi)-Tash-York-at-Fringe-Flavours-Night-Market,-photograph-by-Tom-Noble-Creative.jpg");
  }

  .musical-theatre {
    background-image: url("~@/assets/img/2025/26-Musical-Theatre-Pretty-Woman-The-Musical-Australia---Photography-by-Daniel-Boud-(2).jpg");
  }

  .opera {
    background-image: url("~@/assets/img/2025/27-Opera-Danielle-de-Niese-and-Abraham-Bretón-in-Opera-Australia's-production-of-Carmen-at-Regent-Theatre,-Melbourne.-Photo-by-Jeff-Busby-(1).jpg");
  }

  .special-events {
    background-image: url("~@/assets/img/2025/28-Special-Events-IMG_9609--Sakinu-Kazangiljan-(2).jpg");
  }

  .theatre {
    background-image: url("~@/assets/img/2025/29-Theatre-The-company-of-Dear-Son,-Queensland-Theatre-Company-and-State-Theatre-Company-South-Australia.-Photo-credit-David-Kelly-(2).jpg");
  }
}
</style>
